import React, { useState } from "react";
import styled from "styled-components";
import Footer from "../components/Footer";
import ProductList from "../components/ProductList";
import { selectCategory, updateCategory } from "../redux/productRedux";
import { useSelector, useDispatch } from "react-redux";

const Container = styled.main`
  h2 {
    margin: 20px;
    font-size: 40px;
    font-weight: 200;
  }

  section:last-child {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
`;
const Filters = styled.section`
  display: flex;
  align-items: center;
  margin: 20px;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }

  span {
    font-size: 20px;
    font-weight: 300;
    margin-right: 20px;

    @media only screen and (max-width: 768px) {
      align-self: flex-start;
    }
  }

  select {
    width: 150px;
    padding: 10px;
    margin-right: 20px;
    cursor: pointer;
    background-color: white;
    border: solid 1px black;
    font-size: 16px;
    font-weight: 300;

    @media only screen and (max-width: 768px) {
      width: 100%;
      margin: 5px 0;
    }
  }
`;

export default function Product() {
  const category = useSelector(selectCategory);
  const dispatch = useDispatch();
  const [price, setPrice] = useState("");

  const handleCategory = e => {
    e.preventDefault();
    const value = e.target.value;
    dispatch(updateCategory(value));
  };

  return (
    <>
      <Container>
        <h2>Products</h2>
        <Filters>
          <span>Filter Products:</span>

          <select name="category" onChange={handleCategory}>
            <option value="">Category</option>
            <option value="man">Man</option>
            <option value="woman">Woman</option>
            <option value="jeans">Jeans</option>
            <option value="coats">Coats</option>
            <option value="sheos">Sheos</option>
          </select>

          <select name="price" onChange={e => setPrice(e.target.value)}>
            <option value="price">Price</option>
            <option value="asc">Price (asc)</option>
            <option value="desc">Price (desc)</option>
          </select>
        </Filters>
        <ProductList sort={price} category={category} />
      </Container>
      <Footer />
    </>
  );
}
